import { useTranslation } from 'react-i18next';
import './LoadingSpinner.scss';

interface LoadingSpinnerProps {
  text?: string;
}

// Block-level loading state for pages and sections. Colours follow the design-system
// accent. Without `text`, screen readers still hear a "Loading…" status.
export const LoadingSpinner = ({ text }: LoadingSpinnerProps) => {
  const { t } = useTranslation();
  return (
    <div className="loading-container" role="status" aria-live="polite">
      <div className="spinner-wrapper" aria-hidden="true">
        <div className="spinner-ring spinner-ring--outer" />
        <div className="spinner-ring spinner-ring--inner" />
        <div className="spinner-dot" />
      </div>
      {text ? <p className="loading-text">{text}</p> : <span className="visually-hidden">{t('tableWidget.loading')}</span>}
    </div>
  );
};
